import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import { fetchSamples } from "../sample_reporting/Utils/SamplesFetch";
import ScheduleTestingSearchForm from "./ScheduleTestingSearchForm";

function ScheduleTestingSearch({ onSearch, laboratory_company_id }, ref) {
  // save parameters of the last search so we can re-run it when reloading data
  const [lastSearchParams, setLastSearchParams] = useState({});

  const findSamples = ({
    testingCategory,
    company_id,
    company_branch_id,
    dateFilter,
    start_date,
    end_date,
    received,
    scheduled_status,
    received_by_company_branch_id,
  }) => {
    const searchParams = {
      company_id,
      start_date,
      end_date,
      company_branch_id,
      testing_category_id: testingCategory,
      date_filter: dateFilter,
      received,
      scheduled_status,
      include_scheduling_information: true,
      laboratory_company_id,
      received_by_company_branch_id,
    };
    setLastSearchParams(searchParams);
    return fetchSamples(searchParams).then(onSearch);
  };

  useImperativeHandle(ref, () => ({
    search: () => findSamples(lastSearchParams),
  }));

  return <ScheduleTestingSearchForm onSubmit={findSamples} laboratory_company_id={laboratory_company_id} />;
}

ScheduleTestingSearch = forwardRef(ScheduleTestingSearch);

export default ScheduleTestingSearch;
